var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import * as React from "react";
import { Icon } from "@fluentui/react/lib/Icon";
import { Link } from "@fluentui/react/lib/Link";
import { mergeStyles } from "@fluentui/react/lib/Styling";
class ExternalLink extends React.Component {
  render() {
    const _a = this.props, { className, iconProps, text } = _a, rest = __objRest(_a, ["className", "iconProps", "text"]);
    return /* @__PURE__ */ jsxs(
      Link,
      __spreadProps(__spreadValues({
        target: "_blank",
        rel: "noopener noreferrer"
      }, rest), {
        className: mergeStyles(
          {
            fontSize: "14px",
            lineHeight: "20px"
          },
          className
        ),
        children: [
          text,
          iconProps && /* @__PURE__ */ jsxs(Fragment, { children: [
            " ",
            /* @__PURE__ */ jsx(
              Icon,
              __spreadProps(__spreadValues({}, iconProps), {
                className: mergeStyles(
                  { fontSize: "18px", height: "20px", margin: 0, padding: 0, verticalAlign: "middle" },
                  iconProps.className
                )
              })
            )
          ] })
        ]
      })
    );
  }
}
export {
  ExternalLink,
  ExternalLink as default
};
//# sourceMappingURL=ExternalLink.js.map
